export type DiagnosisStatus = 'open' | 'closed';

export function isDiagnosisClosed(diagnosis: any): boolean {
  const status = String(diagnosis?.status ?? '').toLowerCase();
  if (status === 'closed') return true;
  if (status === 'open') return false;
  // Fallback transitorio per eventuali dati legacy.
  return Boolean(diagnosis?.closed);
}

